import { createContext } from "react";

const ContabilidadReportesContext = createContext();

export default ContabilidadReportesContext;
